export const getPublicUrl = (path) => {
  return process.env.PUBLIC_URL + path;
}

export const getBaseUrl = () => {
  return process.env.PUBLIC_URL ;
}

